import React from 'react';
import Link from '../Link';
import Icon from '../icons/Icon';

export default class ToolbarButton extends React.Component {
    render() {
        let classes = ['ToolbarButton', this.props.className];

        return <Link className={classes.join(' ')} href={this.props.href} onClick={this.props.onClick} style={{backgroundColor: this.props.backgroundColor}}>
            <Icon className="full-center" src={this.props.src} size={25} color={this.props.iconColor}/>
        </Link>
    }
}
